import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_BANNER_FULFILLED: (state, action) => ({
			...state,
			image: action.payload.image,
			thumbnail: action.payload.thumbnail,
		}),
	},
	{
		image: '',
		thumbnail: '',
	},
);



// WEBPACK FOOTER //
// ./src/reducers/banner.js